import React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

const feedbackOptions = {
  'ON_RETURN': { label: 'On Return', description: 'Feedback provided when the lesson is returned by educator' },
  'ON_SUBMISSION': { label: 'On Submission', description: 'Feedback returned when the student submits the lesson' },
  'INSTANT': { label: 'Instant', description: 'Feedback is returned after every question is answered' }
}

const FeedbackTypeSelector = ({
  value,
  onValueChange,
  disabled = false,
  isLoading = false,
  className = ''
}) => {
  return (
    <Select
      className={`w-full ${className}`}
      onValueChange={onValueChange}
      value={value}
      disabled={disabled}
    >
      <SelectTrigger className="w-full font-normal">
        <SelectValue placeholder="Select feedback type">
          {isLoading && 'Updating...'}
          {!isLoading && value && feedbackOptions[value]?.label}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="w-full max-w-[calc(100vw-2rem)]" sideOffset={4}>
        {Object.entries(feedbackOptions).map(([optionValue, option]) => (
          <SelectItem key={optionValue} value={optionValue} className="whitespace-normal">
            <div className="w-full pr-4">
              <p className='leading-tight font-medium'>{option.label}</p>
              <p className='text-xs text-muted-foreground leading-tight whitespace-normal break-words'>{option.description}</p>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default FeedbackTypeSelector 
